import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { InviterUtilisateursModel } from 'src/models/pilotage/inviterUtilisateursModel';
import { ResultInviterUtilisateursModel } from 'src/models/pilotage/resultInviterUtilisateursModel';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { SnackBarService } from 'src/services/snack-bar.service';
import { UtilisateursDejaEnregistresDialogComponent } from '../utilisateurs-deja-enregistres-dialog/utilisateurs-deja-enregistres-dialog.component';
import { catchError, of, Subscription, tap, throwError  } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommunInviteComponent } from '../commun-invite/commun-invite.component';

import { EtiquetteModel } from 'src/models/pilotage/contextePilotageUtilisateurModel';

@Component({
    selector: 'app-invite-utilisateur-dialog',
    templateUrl: './invite-utilisateur-dialog.component.html',
    styleUrls: ['./invite-utilisateur-dialog.component.scss'],
    imports: [MatDialogModule, TranslateModule, MatProgressSpinnerModule, CommunInviteComponent]
})
export class InviteUtilisateurDialogComponent implements OnInit {
  private sub = new Subscription();
  roleEntites: { id: number, nom: string }[] = [];
  courriels: string[] = [];
  entiteIdSelectionne!: number;
  etiquettesAccessibles: EtiquetteModel[] = [];
  etiquettesSelectionnees: EtiquetteModel[] = [];
  isLoading: boolean = false;
  groupeEtiquettes: EtiquetteModel[] = [];

  constructor(
    private dialogRefInvite: MatDialogRef<InviteUtilisateurDialogComponent>,
    private dialogRefDejaEnregistres: MatDialog,
    private utilisateurService: UtilisateurService,
    private snackbarService: SnackBarService,
    private translate: TranslateService,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.roleEntites = this.utilisateurService.contexteUtilisateur.entitesAccessibles
    .filter(re => !re.estGroupe)
    .map(re => ({
      id: re.entiteId,
      nom: re.nom,
      estActif: re.estActif
    }));


    if (this.roleEntites.length === 1) {
      this.entiteIdSelectionne = this.roleEntites[0].id;
    } else {
      const currentEntiteId = this.utilisateurService.entiteUtilisateurSelectionnee?.entiteId;
      if (currentEntiteId && this.roleEntites.some(e => e.id === currentEntiteId)) {
        this.entiteIdSelectionne = currentEntiteId;
      }
    }

    this.initializeGroupEtiquettes();
    this.updateAvailableEtiquettes();
  }

  private initializeGroupEtiquettes(): void {
    const groupEntites = this.utilisateurService.contexteUtilisateur.entitesAccessibles
      .filter(e => e.estGroupe)
      .map(e => e.entiteId);

    this.groupeEtiquettes = this.utilisateurService.contexteUtilisateur.toutesLesEtiquettes
      .filter(e => e.entiteIds.some(id => groupEntites.includes(id)));
  }

  private updateAvailableEtiquettes(): void {
    let availableEtiquettes = new Set<EtiquetteModel>(this.groupeEtiquettes);

    if (this.entiteIdSelectionne) {
      const entiteEtiquettes = this.utilisateurService.contexteUtilisateur.toutesLesEtiquettes
        .filter(e => e.entiteIds.some(id => id === Number(this.entiteIdSelectionne)));
      entiteEtiquettes.forEach(e => availableEtiquettes.add(e));
    }

    this.etiquettesAccessibles = [...Array.from(availableEtiquettes)];
  }



  onEmailsChanged(courriels: string[]): void {
    this.courriels = courriels;
  }

  onEntitySelected(entiteId: number): void {
    this.entiteIdSelectionne = entiteId;
    this.updateAvailableEtiquettes();
  }

  onEtiquettesSelectionnees(etiquettes: EtiquetteModel[]): void {
    this.etiquettesSelectionnees = etiquettes;
  }

  onCancel(): void {
    this.dialogRefInvite.close();
  }

  onSubmit(): void {
    this.isLoading = true;
    const inviterUtilisateurs: InviterUtilisateursModel = {
      courriels: this.courriels,
      entiteId: this.entiteIdSelectionne,
      etiquetteIds: this.etiquettesSelectionnees.map(e => e.etiquetteId)
    };

    this.utilisateurService.inviterUtilisateurs(inviterUtilisateurs).pipe(
      tap((response: ResultInviterUtilisateursModel) => {
        if (response) {
          this.dialogRefDejaEnregistres.open(UtilisateursDejaEnregistresDialogComponent, {
            data: response
          });
        }
      }),
      catchError((error) => {
        console.error('Erreur lors de l\'invitation des utilisateurs', error);
        return throwError(() => error);
      })
    ).subscribe({
      next: () => {
        this.isLoading = false;
        this.dialogRefInvite.close(true);
      },
      error: () => {
        this.isLoading = false;
        this.dialogRefInvite.close(false);
      }
    });
  }
}
